import { type InvestmentListColumnName } from "./types";

export const NP_INVESTMENTS_LIST_COLUMNS = [
  "commitment",
  "unfundedCommitment",
  "contributions",
  "distributions",
  "value",
  "totalExposure",
] as const;

// To be used for the temporary investment list implementation soon to be replaced by the new
// mobile friendly code.  (RKT-50)
export const ALL_INVESTMENT_LIST_COLUMNS_TEMP = [
  "percentOwnership",
  "commitment",
  "units",
  "unitValue",
  "unfundedCommitment",
  "contributions",
  "redemptions",
  "distributions",
  "value",
  "totalExposure",
  "equityBalance",
  "irr",
  "dpi",
  "rvpi",
  "tvpi",
  "cocYield",
] as const;

export const COLUMN_TO_NAME: Record<InvestmentListColumnName, string> = {
  percentOwnership: "Ownership",
  commitment: "Commitment",
  units: "Units",
  unitValue: "Unit value",
  contributions: "Contributions",
  redemptions: "Redemptions",
  distributions: "Distributions",
  value: "Value",
  totalExposure: "Total exposure",
  unfundedCommitment: "Unfunded",
  equityBalance: "Equity balance",
  irr: "IRR",
  dpi: "DPI",
  rvpi: "RVPI",
  tvpi: "TVPI",
  cocYield: "Yield",
} as const;

export const MONEY_INVESTMENT_LIST_COLUMNS = [
  "commitment",
  "unitValue",
  "unfundedCommitment",
  "contributions",
  "redemptions",
  "distributions",
  "value",
  "totalExposure",
  "equityBalance",
] as const;

export const PAGE_TITLES = {
  Home: "Home",
  Investments: "Investments",
  Emails: "Emails",
  Documents: "Documents",
  TaxDocuments: "Tax documents",
  Offerings: "Offerings",
  Onboarding: "Onboarding",
  Position: "Position",
  TermsAndPrivacy: "Terms and privacy",
  PageNotFound: "Page Not Found",
  Settings: "Settings",
  Profile: "Profile",
  InvestmentAccounts: "Investment accounts",
  Organization: "Organization settings",
  InvestorProfile: "Investor profile",
  ManagerAccounts: "Manager accounts",
  Login: "Login",
  Activation: "Activate account",
  TwoFASetup: "Set up 2FA",
  Overview: "Overview",
  Contacts: "Contacts",
  Requests: "Requests",
};

export const GENERAL_PAGE_TITLE = "Juniper Square";

export const DEFAULT_NAVBAR_ITEMS = ["home", "investments", "documents", "emails"];

interface DATE_FORMAT_TYPE {
  long: string;
  short: string;
  shorts: string[];
}

export type DATE_TYPE = "long" | "short";

type DATE_FORMATS_TYPE = Record<string, DATE_FORMAT_TYPE>;

export const DATE_FORMATS: DATE_FORMATS_TYPE = {
  "MM/DD/YYYY": {
    long: "MMM d, yyyy",
    short: "MM/dd/yyyy",
    shorts: [
      "MM/dd/yyyy",
      "M/d/yyyy",
      "MM/d/yyyy",
      "M/dd/yyyy",
      "MM/dd/yy",
      "M/d/yy",
      "MM/d/yy",
      "M/dd/yy",
    ],
  },
  "DD/MM/YYYY": {
    long: "d MMM yyyy",
    short: "dd/MM/yyyy",
    shorts: [
      "dd/MM/yyyy",
      "d/M/yyyy",
      "d/MM/yyyy",
      "dd/M/yyyy",
      "dd/MM/yy",
      "d/M/yy",
      "d/MM/yy",
      "dd/M/yy",
    ],
  },
  "YYYY-MM-DD": {
    long: "yyyy-MM-dd",
    short: "yyyy-MM-dd",
    shorts: [
      "yyyy-MM-dd",
      "yyyy-M-d",
      "yyyy-MM-d",
      "yyyy-M-dd",
      "yy-MM-dd",
      "yy-M-d",
      "yy-MM-d",
      "yy-M-dd",
    ],
  },
};

export const TIME_FORMATS = {
  "12-hour": "h:mm a",
  "24-hour": "k:mm",
};
